/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { AdminInfo5 } from '../model/adminInfo5';
import { ComEventRetrieveResponse } from '../model/comEventRetrieveResponse';
import { ComTemplateAssignCreateRequest } from '../model/comTemplateAssignCreateRequest';
import { ComTemplateAssignCreateResponse } from '../model/comTemplateAssignCreateResponse';
import { ComTemplateCreateRequest } from '../model/comTemplateCreateRequest';
import { ComTemplateCreateRequest2 } from '../model/comTemplateCreateRequest2';
import { ComTemplateCreateResponse } from '../model/comTemplateCreateResponse';
import { ComTemplateCreateResponse2 } from '../model/comTemplateCreateResponse2';
import { ComTemplatePutRequestInfo } from '../model/comTemplatePutRequestInfo';
import { ComTemplatePutRequestInfo2 } from '../model/comTemplatePutRequestInfo2';
import { ComTemplatePutResponseInfo } from '../model/comTemplatePutResponseInfo';
import { ComTemplatePutResponseInfo2 } from '../model/comTemplatePutResponseInfo2';
import { ComTemplateRetrieveNamesResponse } from '../model/comTemplateRetrieveNamesResponse';
import { ComTemplateRetrieveResponse } from '../model/comTemplateRetrieveResponse';
import { ComTemplateRetrieveResponse2 } from '../model/comTemplateRetrieveResponse2';
import { ComTemplateRetrieveResponse3 } from '../model/comTemplateRetrieveResponse3';
import { ComTemplateSummaryRequestInfo } from '../model/comTemplateSummaryRequestInfo';
import { ComTemplateSummaryResponseInfo } from '../model/comTemplateSummaryResponseInfo';
import { EmailCreateResponse } from '../model/emailCreateResponse';
import { EmailInfo } from '../model/emailInfo';
import { EmailRetrieveResponse } from '../model/emailRetrieveResponse';
import { EmailStatusResponse } from '../model/emailStatusResponse';
import { ErrorMessage } from '../model/errorMessage';
import { InlineResponse20011 } from '../model/inlineResponse20011';
import { NotificationRetrieveRequest } from '../model/notificationRetrieveRequest';
import { NotificationRetrieveResponse } from '../model/notificationRetrieveResponse';
import { NotificationSendRequest } from '../model/notificationSendRequest';
import { NotificationSendResponse } from '../model/notificationSendResponse';
import { ReceiptRetrieve } from '../model/receiptRetrieve';
import { RequestInfo2 } from '../model/requestInfo2';
import { ResponseInfo } from '../model/responseInfo';
import { RetrieveResponse } from '../model/retrieveResponse';
import { SmsCreateRequest } from '../model/smsCreateRequest';
import { SmsCreateResponse } from '../model/smsCreateResponse';
import { SmsGetStatusResponse } from '../model/smsGetStatusResponse';
import { SmsRetrieveIdResponse } from '../model/smsRetrieveIdResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ComMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * ComMgr_AdminInfo, Get the Admin Info
     * Gives the latest Version Control and Host Info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1AdminInfoGet(observe?: 'body', reportProgress?: boolean): Observable<AdminInfo5>;
    public comMgrV1AdminInfoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminInfo5>>;
    public comMgrV1AdminInfoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminInfo5>>;
    public comMgrV1AdminInfoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AdminInfo5>(`${this.basePath}/ComMgr/V1/Admin/Info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_ComEventRetrieve, Retrieve all ComEvent records
     * Retrieve ComEvent
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComEventGet(observe?: 'body', reportProgress?: boolean): Observable<ComEventRetrieveResponse>;
    public comMgrV1ComEventGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComEventRetrieveResponse>>;
    public comMgrV1ComEventGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComEventRetrieveResponse>>;
    public comMgrV1ComEventGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<ComEventRetrieveResponse>(`${this.basePath}/ComMgr/V1/ComEvent`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_RetrieveComLog, Retrieve ComLog
     * Retrieve ComLog,
     * @param OrgId Enter the OrgId
     * @param FacilityId Enter the FacilityId
     * @param ComTemplateId Enter the ComTemplateId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Kind Enter the Kind
     * @param Level Enter the Level
     * @param Channel Enter the Channel
     * @param ComEventId Enter the ComEventId
     * @param RequestId Enter the RequestId
     * @param ComType Enter the Communication Type
     * @param From Enter the From
     * @param To Enter the To
     * @param RelatedEntityId Enter the RelatedEntityId
     * @param RelatedEntity Enter the RelatedEntity
     * @param StartDateTime Enter the StartDateTime for CreateDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format
     * @param EndDateTime Enter the EndDateTime for CreateDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format, Range between Start and EndateTime be less than 7 days
     * @param PageNumber Enter the page number, where page number starts from 1.
     * @param PageSize Enter records per page. Default page size is 5000.
     * @param SortBy Select Input Type
     * @param SortOrder Select Order Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComLogGet(OrgId?: number, FacilityId?: number, ComTemplateId?: number, ConsumerNumber?: string, Kind?: string, Level?: string, Channel?: string, ComEventId?: number, RequestId?: string, ComType?: string, From?: string, To?: string, RelatedEntityId?: string, RelatedEntity?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'body', reportProgress?: boolean): Observable<RetrieveResponse>;
    public comMgrV1ComLogGet(OrgId?: number, FacilityId?: number, ComTemplateId?: number, ConsumerNumber?: string, Kind?: string, Level?: string, Channel?: string, ComEventId?: number, RequestId?: string, ComType?: string, From?: string, To?: string, RelatedEntityId?: string, RelatedEntity?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RetrieveResponse>>;
    public comMgrV1ComLogGet(OrgId?: number, FacilityId?: number, ComTemplateId?: number, ConsumerNumber?: string, Kind?: string, Level?: string, Channel?: string, ComEventId?: number, RequestId?: string, ComType?: string, From?: string, To?: string, RelatedEntityId?: string, RelatedEntity?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RetrieveResponse>>;
    public comMgrV1ComLogGet(OrgId?: number, FacilityId?: number, ComTemplateId?: number, ConsumerNumber?: string, Kind?: string, Level?: string, Channel?: string, ComEventId?: number, RequestId?: string, ComType?: string, From?: string, To?: string, RelatedEntityId?: string, RelatedEntity?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (FacilityId !== undefined) {
            queryParameters = queryParameters.set('FacilityId', <any>FacilityId);
        }
        if (ComTemplateId !== undefined) {
            queryParameters = queryParameters.set('ComTemplateId', <any>ComTemplateId);
        }
        if (ConsumerNumber !== undefined) {
            queryParameters = queryParameters.set('ConsumerNumber', <any>ConsumerNumber);
        }
        if (Kind !== undefined) {
            queryParameters = queryParameters.set('Kind', <any>Kind);
        }
        if (Level !== undefined) {
            queryParameters = queryParameters.set('Level', <any>Level);
        }
        if (Channel !== undefined) {
            queryParameters = queryParameters.set('Channel', <any>Channel);
        }
        if (ComEventId !== undefined) {
            queryParameters = queryParameters.set('ComEventId', <any>ComEventId);
        }
        if (RequestId !== undefined) {
            queryParameters = queryParameters.set('RequestId', <any>RequestId);
        }
        if (ComType !== undefined) {
            queryParameters = queryParameters.set('ComType', <any>ComType);
        }
        if (From !== undefined) {
            queryParameters = queryParameters.set('From', <any>From);
        }
        if (To !== undefined) {
            queryParameters = queryParameters.set('To', <any>To);
        }
        if (RelatedEntityId !== undefined) {
            queryParameters = queryParameters.set('RelatedEntityId', <any>RelatedEntityId);
        }
        if (RelatedEntity !== undefined) {
            queryParameters = queryParameters.set('RelatedEntity', <any>RelatedEntity);
        }
        if (StartDateTime !== undefined) {
            queryParameters = queryParameters.set('StartDateTime', <any>StartDateTime);
        }
        if (EndDateTime !== undefined) {
            queryParameters = queryParameters.set('EndDateTime', <any>EndDateTime);
        }
        if (PageNumber !== undefined) {
            queryParameters = queryParameters.set('PageNumber', <any>PageNumber);
        }
        if (PageSize !== undefined) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }
        if (SortBy !== undefined) {
            queryParameters = queryParameters.set('SortBy', <any>SortBy);
        }
        if (SortOrder !== undefined) {
            queryParameters = queryParameters.set('SortOrder', <any>SortOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<RetrieveResponse>(`${this.basePath}/ComMgr/V1/ComLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_ComQueueReProcess, ReProcessing the ComQueue
     * ReProcessing the ComQueue which are in Failed or Error State
     * @param Id Enter a ComQueue Id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComQueueIdPost(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public comMgrV1ComQueueIdPost(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public comMgrV1ComQueueIdPost(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public comMgrV1ComQueueIdPost(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling comMgrV1ComQueueIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<any>(`${this.basePath}/ComMgr/V1/ComQueue/${encodeURIComponent(String(Id))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_ActivatedTemplates, Retrieves activated template records in heirarchical order as per Type, GroupId/OrgId, Level
     * Retrieves activated template records in heirarchical order as per Type, GroupId/OrgId, Level
     * @param Level Select Level
     * @param Type Select Type
     * @param GroupId Enter the GroupId
     * @param OrgId Enter the OrgId
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateActivatedTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<ComTemplateRetrieveResponse3>;
    public comMgrV1ComTemplateActivatedTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateRetrieveResponse3>>;
    public comMgrV1ComTemplateActivatedTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateRetrieveResponse3>>;
    public comMgrV1ComTemplateActivatedTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling comMgrV1ComTemplateActivatedTemplateGet.');
        }
        if (Type === null || Type === undefined) {
            throw new Error('Required parameter Type was null or undefined when calling comMgrV1ComTemplateActivatedTemplateGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Level !== undefined) {
            queryParameters = queryParameters.set('Level', <any>Level);
        }
        if (GroupId !== undefined) {
            queryParameters = queryParameters.set('GroupId', <any>GroupId);
        }
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (FacilityId !== undefined) {
            queryParameters = queryParameters.set('FacilityId', <any>FacilityId);
        }
        if (Type !== undefined) {
            queryParameters = queryParameters.set('Type', <any>Type);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<ComTemplateRetrieveResponse3>(`${this.basePath}/ComMgr/V1/ComTemplate/ActivatedTemplate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_CreateComTemplateAssign, Template assignment
     * Assign a template that needs to be used for notifications through channel ie Sms/Email
     * @param Request Enter a JSON which would activate a template for notification.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateAssignActivatePost(Request: ComTemplateAssignCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<ComTemplateAssignCreateResponse>;
    public comMgrV1ComTemplateAssignActivatePost(Request: ComTemplateAssignCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateAssignCreateResponse>>;
    public comMgrV1ComTemplateAssignActivatePost(Request: ComTemplateAssignCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateAssignCreateResponse>>;
    public comMgrV1ComTemplateAssignActivatePost(Request: ComTemplateAssignCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1ComTemplateAssignActivatePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ComTemplateAssignCreateResponse>(`${this.basePath}/ComMgr/V1/ComTemplateAssign/Activate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_ComTemplateRetrieve, Retrieve all ComTemplate records as per Type, GroupId/OrgId, Level
     * Retrieve ComTemplate
     * @param Level Select Level
     * @param Type Select Type
     * @param GroupId Enter the GroupId
     * @param OrgId Enter the OrgId
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<ComTemplateRetrieveResponse>;
    public comMgrV1ComTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateRetrieveResponse>>;
    public comMgrV1ComTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateRetrieveResponse>>;
    public comMgrV1ComTemplateGet(Level: string, Type: string, GroupId?: number, OrgId?: number, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling comMgrV1ComTemplateGet.');
        }
        if (Type === null || Type === undefined) {
            throw new Error('Required parameter Type was null or undefined when calling comMgrV1ComTemplateGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Level !== undefined) {
            queryParameters = queryParameters.set('Level', <any>Level);
        }
        if (GroupId !== undefined) {
            queryParameters = queryParameters.set('GroupId', <any>GroupId);
        }
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (FacilityId !== undefined) {
            queryParameters = queryParameters.set('FacilityId', <any>FacilityId);
        }
        if (Type !== undefined) {
            queryParameters = queryParameters.set('Type', <any>Type);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<ComTemplateRetrieveResponse>(`${this.basePath}/ComMgr/V1/ComTemplate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_DeleteComTemplate, Delete the requested Template
     * Delete the requested Template
     * @param Id Enter the Template id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public comMgrV1ComTemplateIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public comMgrV1ComTemplateIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public comMgrV1ComTemplateIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling comMgrV1ComTemplateIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/ComMgr/V1/ComTemplate/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_PutComTemplate, Create Template as per Id
     * Create Template as per Id
     * @param Id Enter the template id
     * @param Request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateIdPut(Id: number, Request: ComTemplatePutRequestInfo2, observe?: 'body', reportProgress?: boolean): Observable<ComTemplatePutResponseInfo2>;
    public comMgrV1ComTemplateIdPut(Id: number, Request: ComTemplatePutRequestInfo2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplatePutResponseInfo2>>;
    public comMgrV1ComTemplateIdPut(Id: number, Request: ComTemplatePutRequestInfo2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplatePutResponseInfo2>>;
    public comMgrV1ComTemplateIdPut(Id: number, Request: ComTemplatePutRequestInfo2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling comMgrV1ComTemplateIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1ComTemplateIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ComTemplatePutResponseInfo2>(`${this.basePath}/ComMgr/V1/ComTemplate/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_RetrieveComTemplateList, Retrieve all ComTemplate records as per GroupId/OrgId, Level
     * Retrieve ComTemplate List
     * @param Level Select Level
     * @param GroupId Enter the GroupId
     * @param OrgId Enter the OrgId
     * @param FacilityId Enter the FacilityId
     * @param Ids Enter ComTemplate ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateListGet(Level: string, GroupId?: number, OrgId?: number, FacilityId?: number, Ids?: string, observe?: 'body', reportProgress?: boolean): Observable<ComTemplateRetrieveResponse2>;
    public comMgrV1ComTemplateListGet(Level: string, GroupId?: number, OrgId?: number, FacilityId?: number, Ids?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateRetrieveResponse2>>;
    public comMgrV1ComTemplateListGet(Level: string, GroupId?: number, OrgId?: number, FacilityId?: number, Ids?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateRetrieveResponse2>>;
    public comMgrV1ComTemplateListGet(Level: string, GroupId?: number, OrgId?: number, FacilityId?: number, Ids?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling comMgrV1ComTemplateListGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Level !== undefined) {
            queryParameters = queryParameters.set('Level', <any>Level);
        }
        if (GroupId !== undefined) {
            queryParameters = queryParameters.set('GroupId', <any>GroupId);
        }
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (FacilityId !== undefined) {
            queryParameters = queryParameters.set('FacilityId', <any>FacilityId);
        }
        if (Ids !== undefined) {
            queryParameters = queryParameters.set('Ids', <any>Ids);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<ComTemplateRetrieveResponse2>(`${this.basePath}/ComMgr/V1/ComTemplate/List`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_CreateComTemplateList, create a template
     * Create a template for sending notifications through channel ie Sms/Email
     * @param Request Enter template specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateListPost(Request: ComTemplateCreateRequest2, observe?: 'body', reportProgress?: boolean): Observable<ComTemplateCreateResponse2>;
    public comMgrV1ComTemplateListPost(Request: ComTemplateCreateRequest2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateCreateResponse2>>;
    public comMgrV1ComTemplateListPost(Request: ComTemplateCreateRequest2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateCreateResponse2>>;
    public comMgrV1ComTemplateListPost(Request: ComTemplateCreateRequest2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1ComTemplateListPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ComTemplateCreateResponse2>(`${this.basePath}/ComMgr/V1/ComTemplate/List`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_UpdateComTemplateList, Update Template List
     * Update Template List
     * @param Request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateListPut(Request: ComTemplatePutRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ComTemplatePutResponseInfo>;
    public comMgrV1ComTemplateListPut(Request: ComTemplatePutRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplatePutResponseInfo>>;
    public comMgrV1ComTemplateListPut(Request: ComTemplatePutRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplatePutResponseInfo>>;
    public comMgrV1ComTemplateListPut(Request: ComTemplatePutRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1ComTemplateListPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ComTemplatePutResponseInfo>(`${this.basePath}/ComMgr/V1/ComTemplate/List`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_ComTemplateRetrieveAllNames, Retrieve all ComTemplate names
     * Retrieve all ComTemplate names
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateNamesGet(observe?: 'body', reportProgress?: boolean): Observable<ComTemplateRetrieveNamesResponse>;
    public comMgrV1ComTemplateNamesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateRetrieveNamesResponse>>;
    public comMgrV1ComTemplateNamesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateRetrieveNamesResponse>>;
    public comMgrV1ComTemplateNamesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<ComTemplateRetrieveNamesResponse>(`${this.basePath}/ComMgr/V1/ComTemplate/Names`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_CreateComTemplate, create a template
     * Create a template for sending notifications through channel ie Sms/Email
     * @param Request Enter template specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplatePost(Request: ComTemplateCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<ComTemplateCreateResponse>;
    public comMgrV1ComTemplatePost(Request: ComTemplateCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateCreateResponse>>;
    public comMgrV1ComTemplatePost(Request: ComTemplateCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateCreateResponse>>;
    public comMgrV1ComTemplatePost(Request: ComTemplateCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1ComTemplatePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ComTemplateCreateResponse>(`${this.basePath}/ComMgr/V1/ComTemplate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_ComTemplateSummary, Get ComTemplate Summary
     * Get ComTemplate Summary
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1ComTemplateSummaryPost(Request: ComTemplateSummaryRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ComTemplateSummaryResponseInfo>;
    public comMgrV1ComTemplateSummaryPost(Request: ComTemplateSummaryRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComTemplateSummaryResponseInfo>>;
    public comMgrV1ComTemplateSummaryPost(Request: ComTemplateSummaryRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComTemplateSummaryResponseInfo>>;
    public comMgrV1ComTemplateSummaryPost(Request: ComTemplateSummaryRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1ComTemplateSummaryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ComTemplateSummaryResponseInfo>(`${this.basePath}/ComMgr/V1/ComTemplate/Summary`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_RetrieveEmail, Retrieve the Email request
     * Retrieve the Email request by using given Id
     * @param Id Enter the Id that needs to be retrieved from ComLog Table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1EmailIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<EmailRetrieveResponse>;
    public comMgrV1EmailIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailRetrieveResponse>>;
    public comMgrV1EmailIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailRetrieveResponse>>;
    public comMgrV1EmailIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling comMgrV1EmailIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<EmailRetrieveResponse>(`${this.basePath}/ComMgr/V1/Email/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_EmailStatus, Get the latest status of an Email transaction
     * Gives the latest status of the Email transaction based on the eMessageId passed in. The events are returned in an array to show all events that occurred for the transaction. The status will let you know if it is still active or if the transaction is complete. Once the status is complete you will no longer recieve updates.
     * @param Id Enter the Id that needs to be retrieved from ComLog Table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1EmailIdStatusGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<EmailStatusResponse>;
    public comMgrV1EmailIdStatusGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailStatusResponse>>;
    public comMgrV1EmailIdStatusGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailStatusResponse>>;
    public comMgrV1EmailIdStatusGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling comMgrV1EmailIdStatusGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<EmailStatusResponse>(`${this.basePath}/ComMgr/V1/Email/${encodeURIComponent(String(Id))}/Status`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_CreateEmail, Send a Email
     * Send a Email to the intended recipient(s) for electronic signature, if succesful an eMessageId will be returned.
     * @param Request Enter the Email specific information in the JSON format.
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1EmailPost(Request: EmailInfo, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<EmailCreateResponse>;
    public comMgrV1EmailPost(Request: EmailInfo, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailCreateResponse>>;
    public comMgrV1EmailPost(Request: EmailInfo, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailCreateResponse>>;
    public comMgrV1EmailPost(Request: EmailInfo, OrgId?: number, GroupId?: number, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1EmailPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<EmailCreateResponse>(`${this.basePath}/ComMgr/V1/Email`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_GetReceipt, Get Receipt
     * Get Receipt
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter Receipt info in JSON format.
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1NotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: ReceiptRetrieve, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse20011>;
    public comMgrV1NotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: ReceiptRetrieve, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse20011>>;
    public comMgrV1NotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: ReceiptRetrieve, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse20011>>;
    public comMgrV1NotificationReceiptPost(OrgId: number, ConsumerNumber: string, Request: ReceiptRetrieve, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling comMgrV1NotificationReceiptPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling comMgrV1NotificationReceiptPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1NotificationReceiptPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<InlineResponse20011>(`${this.basePath}/ComMgr/V1/Notification/Receipt`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_SendNotification, ability To Send Notification
     * Ability To Send Notification
     * @param Request Enter template specific information in the JSON format.
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param Level Select level
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1NotificationSendPost(Request: NotificationSendRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, ConsumerNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<NotificationSendResponse>;
    public comMgrV1NotificationSendPost(Request: NotificationSendRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, ConsumerNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationSendResponse>>;
    public comMgrV1NotificationSendPost(Request: NotificationSendRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, ConsumerNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationSendResponse>>;
    public comMgrV1NotificationSendPost(Request: NotificationSendRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, ConsumerNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1NotificationSendPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (Level !== undefined && Level !== null) {
            headers = headers.set('Level', String(Level));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NotificationSendResponse>(`${this.basePath}/ComMgr/V1/Notification/Send`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_NotificationRetrieve, Retrieves current and latest templates assigned to OrgId
     * Retrieves current and latest template assigned to OrgId
     * @param Request Enter a JSON which would activate a template for notification.
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param Level Select level
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1NotificationTemplatePost(Request: NotificationRetrieveRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, observe?: 'body', reportProgress?: boolean): Observable<NotificationRetrieveResponse>;
    public comMgrV1NotificationTemplatePost(Request: NotificationRetrieveRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationRetrieveResponse>>;
    public comMgrV1NotificationTemplatePost(Request: NotificationRetrieveRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationRetrieveResponse>>;
    public comMgrV1NotificationTemplatePost(Request: NotificationRetrieveRequest, OrgId?: number, GroupId?: number, FacilityId?: number, Level?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1NotificationTemplatePost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (Level !== undefined && Level !== null) {
            headers = headers.set('Level', String(Level));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NotificationRetrieveResponse>(`${this.basePath}/ComMgr/V1/Notification/Template`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_PreviewTemplate, Get Preview template
     * Get Preview template
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1PreviewPost(Request: RequestInfo2, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo>;
    public comMgrV1PreviewPost(Request: RequestInfo2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo>>;
    public comMgrV1PreviewPost(Request: RequestInfo2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo>>;
    public comMgrV1PreviewPost(Request: RequestInfo2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1PreviewPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo>(`${this.basePath}/ComMgr/V1/Preview`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_RetrieveSms, Retrieve the Sms request
     * Retrieve the Sms request using given Id
     * @param Id Enter the Id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1SmsIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<SmsRetrieveIdResponse>;
    public comMgrV1SmsIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRetrieveIdResponse>>;
    public comMgrV1SmsIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRetrieveIdResponse>>;
    public comMgrV1SmsIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling comMgrV1SmsIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SmsRetrieveIdResponse>(`${this.basePath}/ComMgr/V1/Sms/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_SmsStatus, Retrieve Sms status
     * Retrieve Sms status
     * @param Id Enter the Id that needs to be retrieved from ComLog Table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1SmsIdStatusGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<SmsGetStatusResponse>;
    public comMgrV1SmsIdStatusGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsGetStatusResponse>>;
    public comMgrV1SmsIdStatusGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsGetStatusResponse>>;
    public comMgrV1SmsIdStatusGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling comMgrV1SmsIdStatusGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<SmsGetStatusResponse>(`${this.basePath}/ComMgr/V1/Sms/${encodeURIComponent(String(Id))}/Status`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * ComMgr_CreateSms, Create and send a Sms
     * Create and send a Sms
     * @param Request Enter the demographic information about the sms to be sent.
     * @param OrgId Enter the OrgId
     * @param FacilityId Enter the FacilityId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comMgrV1SmsPost(Request: SmsCreateRequest, OrgId?: number, FacilityId?: number, GroupId?: number, observe?: 'body', reportProgress?: boolean): Observable<SmsCreateResponse>;
    public comMgrV1SmsPost(Request: SmsCreateRequest, OrgId?: number, FacilityId?: number, GroupId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsCreateResponse>>;
    public comMgrV1SmsPost(Request: SmsCreateRequest, OrgId?: number, FacilityId?: number, GroupId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsCreateResponse>>;
    public comMgrV1SmsPost(Request: SmsCreateRequest, OrgId?: number, FacilityId?: number, GroupId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling comMgrV1SmsPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<SmsCreateResponse>(`${this.basePath}/ComMgr/V1/Sms`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
